const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiobuttonWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22.734,
    viewBox: "0 0 24 22.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M75.387 14.781a5.376 5.376 0 1 0 5.376 5.376 5.388 5.388 0 0 0-5.376-5.376zm0 1.5a3.875 3.875 0 1 1-3.887 3.876 3.865 3.865 0 0 1 3.882-3.876zm7.546 1.478a.751.751 0 1 0 0 1.5h10.326a.751.751 0 1 0 0-1.5zm-7.549.275a2.031 2.031 0 1 0 1.436.594 2.031 2.031 0 0 0-1.436-.594zm7.477 3.019a.751.751 0 0 0 .072 1.5h4.424a.75.75 0 1 0 0-1.5H82.86zm-7.474 5.709a5.376 5.376 0 1 0 5.376 5.376 5.388 5.388 0 0 0-5.377-5.375zm0 1.5a3.875 3.875 0 1 1-3.887 3.877 3.865 3.865 0 0 1 3.886-3.876zm7.474 1.484a.751.751 0 0 0 .072 1.5h10.325a.75.75 0 0 0 0-1.5H82.86zm.072 3.289a.75.75 0 1 0 0 1.5h4.424a.75.75 0 1 0 0-1.5z",
    transform: "translate(-70.01 -14.781)",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobuttonWidgetIcon);
export default __webpack_public_path__ + "static/media/radiobutton-widget-icon.021ae5289660232ad2f16832837574c3.svg";
export { ForwardRef as ReactComponent };